import Vue from 'vue'
import Router from 'vue-router'

import Projekte from '@/components/Projekte'
import Auftrag from '@/components/Auftrag'
import Anfragen from '@/components/Anfragen'
import Archiv from '@/components/Archiv'
import Benutzer from '@/components/Benutzer'
import BenutzerList from '@/components/BenutzerList'
import Login from '@/components/Login'
import Logout from '@/components/Logout'
import Stammdaten from '@/components/Stammdaten'
import StammdatenList from '@/components/StammdatenList'
import StammdatenEditor from '@/components/StammdatenEditor'
import AGB from '@/components/AGB'
import FAQ from '@/components/FAQ'
import WrappedProfil from '@/components/WrappedProfil'
import Start from '@/components/Start'
import AuftragAnfrage from '@/components/AuftragAnfrage'
import StatusList from '@/components/internal/StatusList.vue'

import NotFound from '@/components/NotFound'

import store from '@/store'
import Role from '@/models/Role'
import utils from '@/utilities'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Start',
      meta: { authorize: [Role.Admin] },
      component: Start
    },
    {
      path: '/auftragAnfrage',
      name: 'AuftragAnfrage',
      component: AuftragAnfrage
    },
    {
      path: '/Benutzer/:id',
      name: 'Benutzer',
      component: Benutzer,
      meta: { authorize: [Role.Admin] }
    },
    {
      path: '/BenutzerList',
      name: 'BenutzerList',
      component: BenutzerList,
      meta: { authorize: [Role.Admin] }
    },
    {
      path: '/anfragen',
      name: 'Anfragen',
      component: Anfragen,
      meta: { authorize: [Role.Admin, Role.Cutter, Role.Disponent, Role.Kunde] }
    },
    {
      path: '/archiv',
      name: 'Archiv',
      component: Archiv,
      meta: { authorize: [Role.Admin, Role.Disponent, Role.Cutter] }
    },
    {
      path: '/statusList',
      name: 'StatusList',
      component: StatusList,
      meta: { authorize: [Role.Admin] }
    },
    {
      path: '/AGB',
      name: 'AGB',
      component: AGB,
      meta: { authorize: [] }
    },
    {
      path: '/Profil',
      name: 'WrappedProfil',
      component: WrappedProfil,
      meta: { authorize: [Role.Admin, Role.Cutter, Role.Disponent, Role.Kunde] }
    },
    {
      path: '/FAQ',
      name: 'FAQ',
      component: FAQ,
      meta: { authorize: [] }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/logout',
      name: 'Logout',
      component: Logout
    },
    {
      path: '/stammdaten',
      name: 'Stammdaten',
      component: Stammdaten,
      meta: { authorize: [Role.Admin] }
    },
    {
      path: '/stammdaten/:type',
      name: 'StammdatenList',
      component: StammdatenList,
      meta: { authorize: [Role.Admin] }
    },
    {
      path: '/stammdaten/create/:type/:id',
      name: 'Bearbeiten',
      component: StammdatenEditor,
      meta: { authorize: [Role.Admin] }
    },
    {
      path: '/projekte/',
      name: 'Projekte',
      component: Projekte,
      meta: { authorize: [Role.Admin, Role.Cutter, Role.Disponent, Role.Kunde] }
    },
    {
      path: '/auftrag/:auftragId',
      name: 'Auftrag',
      component: Auftrag,
      meta: { authorize: [Role.Admin, Role.Cutter, Role.Disponent] }
    },
    {
      path: '/404',
      component: NotFound
    },
    {
      path: '*',
      redirect: '/404'
    }
  ]
})

export default router

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const user = store.getters.user
  const { authorize } = to.meta

  if (authorize) {
    if (!user) {
      // not logged in so redirect to login page with the return url
      return next({ path: '/login', query: { returnUrl: to.path } })
    }
    // check if route is restricted by role
    // HINT were checking the roles included in the token because the roles field in the user object
    // is protected from certain roles to be viewed
    if (authorize.length && !utils.hasAnyRole(utils.tokenRoles(store.getters.token), authorize)) {
      // role not authorised so redirect to home page
      return next({ path: '/anfragen' })
    }
  }

  next()
})



// WEBPACK FOOTER //
// ./src/main/vue/router/index.js